/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface DeleteRecourseCampaignEx$Params {
  recourseCampaignExId: string;
}

export function deleteRecourseCampaignEx(
  http: HttpClient,
  rootUrl: string,
  params: DeleteRecourseCampaignEx$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<{}>> {
  const rb = new RequestBuilder(rootUrl, deleteRecourseCampaignEx.PATH, 'delete');
  if (params) {
    rb.path('recourseCampaignExId', params.recourseCampaignExId, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{}>;
    }),
  );
}

deleteRecourseCampaignEx.PATH = '/service/v1/recourseCampaign/recourseCampaignEx/{recourseCampaignExId}';
